<template>
    <div class="relative">

        <div v-show="errorMessage.length > 0">
            <div class="text-red-600">
                {{ errorMessage }}
            </div>
            <hr/>
        </div>

        <div v-show="promisePending && errorMessage.length === 0" class=" absolute top-0 right-0 animate-spin text-center flex justify-center items-center">
            <i class=" fas fa-spinner w-6 h-6"></i>
        </div>

        <!-- table à exporter -->
        <div v-if="exportMode">
            <label for="smd_table_name">Table à exporter</label>
            <input
                id="smd_table_name"
                class="rounded-md p-1 w-full leading-relaxed mb-2"
                v-model="smd_table_name"
                placeholder="Table(SMD) à exporter"/>
            <hr/>
        </div>

        <div v-if="gotCredentials && credentials.length === 0">
             <!-- nom du credential airtable -->
            <label for="airtable_credential">Credential airtable</label>
            <input
                id="airtable_credential"
                class="rounded-md p-1 w-full leading-relaxed mb-2"
                v-model="airtable_credential"
                placeholder="Credential airtable"/>
        </div>
        <div v-else-if="credentials.length >= 1">
            <!-- nom du credential airtable -->
            <label for="airtable_credential">Credential airtable</label>
            <b-form-select
                id="airtable_credential"
                v-model="airtable_credential" :options="credentials"
                
                class="mb-2">
            </b-form-select>
        </div>
        <div v-if="gotCredentials && (credentials.length === 0 || credentials.length > 1)">
            <b-button :variant="airtable_credential.length > 0 ? 'success' : ''" :disabled="airtable_credential.length === 0"
                @click="() => get_bases()">
                Valider
            </b-button>
        </div>

        <div v-show="baseList.length > 0">
            <!-- base ID -->
            <label for="airtable_base_id">Base Airtable</label>
            <b-form-select
                id="airtable_base_id"
                v-model="airtable_base_id" :options="baseOptions"
                class="mb-2">
            </b-form-select>
        </div>
        
        <div v-show="airtable_base_id.length > 0">
            <!-- table name -->
            <label for="airtable_table_id">Nom de la table Airtable</label>
            <b-form-select
                id="airtable_table_id"
                v-model="airtable_table_id" :options="tableOptions"
                class="mb-2">
            </b-form-select>
        </div>

        <hr/>

        <div v-show="airtable_fields.length > 0" class=" text-green-600">
            Selectionnez une colonne pour la mapper avec les champs de votre table.
        </div>

        <!-- importer -->
        <div v-show="airtable_fields.length > 0" class=" flex items-center ">

            <!-- mapping colonnes -->
            <b-dropdown :variant="airtable_fields.length > 0 ? 'success' : 'warning'" id="mapping-colonnes" text="Mapping colonnes" class="m-md-2">
                <b-dropdown-item
                    v-for="(field, idx) in airtable_fields.filter(f => f.type !== 'multipleAttachments')"
                    v-show="fieldMappings.filter(f => f.airtable_field === field.name).length === 0"
                    :key="'field-map-'+idx"
                    @click="() => fieldMappings.push({ 'airtable_field': field.name, column: field.name, type: field.type})">
                    {{ field.name + " - " + mappedFieldTypes[field.type] }}
                </b-dropdown-item>
            </b-dropdown>

            <!-- <b-dropdown v-if="tableHasDocuments && exportMode === false" :variant="airtable_fields.length > 0 ? 'success' : 'warning'" id="mapping-ged" text="Mapping des tags pour table documents" class="m-md-2">
                <b-dropdown-item
                    v-for="(field, idx) in airtable_fields.filter(f => f.type === 'multipleSelects')"
                    v-show="gedMappings.filter(f => f.airtable_field === field.name).length === 0"
                    :key="'ged-field-map-'+idx"
                    @click="() => gedMappings.push({ 'airtable_field': field.name, column: field.name, type: field.type})">
                    {{ field.name + " - " + mappedFieldTypes[field.type] }}
                </b-dropdown-item>
            </b-dropdown>

            <div v-show="tableHasDocuments && exportMode === false" class="">
                <i
                    v-b-tooltip.hover="{
						variant: 'info',
						title: 'Votre table contient des fichiers, ils seront ajoutés à la table documents.',
					}"
                    class="fas fa-question-circle">

                </i>
            </div> -->
        </div>

        <br/>
        <div v-if="fieldMappings.length > 0 && tablesList.length > 0" class="  text-2xl font-bold">
            <span v-show="exportMode === false">
                Nouvelle table: {{ tablesList.find(t => t.id === airtable_table_id).name }}
            </span>

            <span v-show="exportMode === true">
                Exporter vers: {{ tablesList.find(t => t.id === airtable_table_id).name }}
            </span>
        </div>
        <br/>

        <div v-for="(fieldMapping, idx) in fieldMappings" :key="'airtable-mapping-' + idx">
            <label :for="'airtable_mapping_' + idx">Mapping pour colonne {{ fieldMapping.airtable_field }}</label>

            <div class=" flex items-center">
                <input
                    :id="'airtable_mapping_' + idx"
                    class="rounded-md p-1 w-full leading-relaxed mb-2"
                    v-model="fieldMappings[idx]['column']"
                    :placeholder="`Mapping pour colonne d'origine: ${fieldMapping.airtable_field}`"/> 

                <span class="p-1 mb-2 text-red-500 cursor-pointer font-bold"
                    @click="() => fieldMappings.splice(idx, 1)">
                    X
                </span>
            </div>
        </div>

        <div v-show="tableHasDocuments && gedMappings.length > 0" class="  text-2xl font-bold">
            <hr/>
            Table documents
        </div>
        <br/>

        <div v-for="(gedMapping, idx) in gedMappings" :key="'ged-airtable-mapping-' + idx">
            <label :for="'ged-airtable_mapping_' + idx">Mapping pour colonne {{ gedMapping.airtable_field }}</label>

            <div class=" flex items-center">
                <input
                    :id="'ged-airtable_mapping_' + idx"
                    class="rounded-md p-1 w-full leading-relaxed mb-2"
                    v-model="gedMappings[idx]['column']"
                    :placeholder="`Mapping pour colonne d'origine: ${gedMapping.airtable_field}`"/> 

                <span class="p-1 mb-2 text-red-500 cursor-pointer font-bold"
                    @click="() => gedMappings.splice(idx, 1)">
                    X
                </span>
            </div>
        </div>

        <hr/>
        <b-button
            :disabled="fieldMappings.length === 0"
            @click="() => exportMode ? export_airtable() : import_airtable()"
            variant="success">{{ exportMode ? "Exporter" : "Importer" }}</b-button>
    </div>
</template>

<script>
import airtable_service from "../../services/airtable.js";

export default {
    props: {
        exportMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            airtable_credential: "",
            airtable_base_id: "",
            airtable_table_id: "",

            airtable_fields: [],

            mappedFieldTypes: {
                "multipleAttachments": "(fichier)",
                "Attachment": "(fichier)",
                "multipleSelects": "(tags)",
                "singleLineText": "(texte)",
                "date": "(date)",
                "number": "(nombre)",
            },

            fieldMappings: [],
            gedMappings: [],

            tableHasDocuments: false,

            errorMessage: "",

            baseList: [],
            baseOptions: [],

            tablesList: [],
            tableOptions: [],

            smd_table_name: "",

            credentials: [],

            promisePending: false,

            gotCredentials: false

        }
    },
    methods: {
        get_credentials: async function() {
            this.promisePending = true;

            let credentialsRes = await airtable_service.get_credentials();

            // construct a list with text and value
            this.credentials = credentialsRes.map(c => {
                return { text: c.name, value: c.name };
            });

            console.log("Got credential choices: ", this.credentials);
            if (this.credentials.length > 0) {

                console.log("Assigning airtable credential to: ", this.credentials[0].value);
                this.airtable_credential = this.credentials[0].value;

                await this.get_bases();
            } else {
                this.promisePending = false;
            }
            this.gotCredentials = true;
            // this.promisePending = false;
        },
        import_airtable: async function() {

            this.errorMessage = "";
            // document.body.style.cursor = 'wait';
            this.promisePending = true;

            let table = this.tablesList.find(t => t.id === this.airtable_table_id);

            let smd_table_name = table ? table.name : "import_airtable";

            let res = await airtable_service.import_airtable(this.airtable_credential,
                                                        this.airtable_base_id,
                                                        this.airtable_table_id,
                                                        smd_table_name,
                                                        this.fieldMappings,
                                                        this.gedMappings)
                                                        .catch(err => {
                                                            this.errorMessage = "Erreur lors de l'import de la table";
                                                        });
        
            // document.body.style.cursor = 'default';
            this.promisePending = false;

            if (this.errorMessage.length > 0) {
                return;
            }

            this.$emit("imported");
        },
        get_fields: async function() {
            this.errorMessage = "";

            // change mouse to waiting state
            // document.body.style.cursor = 'wait';
            this.promisePending = true;

            // if base_id is set, try to get the fields
            if (this.info_filled) {

                console.log("table id", this.airtable_table_id);

                let fields = await airtable_service.get_fields(this.airtable_credential,
                                                this.airtable_base_id,
                                                this.airtable_table_id)
                                                .catch(err => {
                                                    this.errorMessage = "Erreur lors de la récupération des champs";
                                                });

                if (fields === undefined || this.errorMessage.length > 0) {
                    // change mouse back to normal
                    // document.body.style.cursor = 'default';
                    this.promisePending = false;
                    return;
                }

                // by default all fields are mapped
                this.fieldMappings = fields.map(f => {
                    return { airtable_field: f.name, column: f.name, type: f.type };
                });

                // inform a dropdown
                this.airtable_fields = fields;
                console.log("fields", fields);
            }

            this.tableHasDocuments = this.airtable_fields.find(f => f.type === "multipleAttachments");

            // change mouse back to normal
            // document.body.style.cursor = 'default';
            this.promisePending = false;

        },
        get_bases: async function() {
            this.errorMessage = "";
            // document.body.style.cursor = 'wait';
            this.promisePending = true;
    
            console.log("Get bases with airtable credential: ", this.airtable_credential);
    
            let result = await airtable_service.get_bases(this.airtable_credential)
                                                        .catch(err => {
                                                            this.errorMessage = err.name === 401 ?
                                                                "Erreur d'authentification, vérifiez le nom et la valeur de votre credential"
                                                                : "Erreur lors de la récupération des bases";
                                                        });

            if (result === undefined) {
                this.promisePending = false;
                return;
            }

            this.baseList = result.bases;

            this.baseOptions = this.baseList.map(b => {
                return { text: b.name, value: b.id };
            });

            if (this.baseOptions.length > 0) {
                this.airtable_base_id = this.baseOptions[0].value;
                // get tables will run automatically after watching base id get updated
                // await this.get_tables();
            } else {
                this.promisePending = false;
                this.errorMessage = "Aucune base trouvée";
            }
 
            // document.body.style.cursor = 'default';
            // this.promisePending = false;

            // console.log("Got bases: ", result.bases);
        },
        get_tables: async function() {
            this.promisePending = true;

            this.errorMessage = "";

            console.log("Get tables with airtable credential: ", this.airtable_credential);
            // document.body.style.cursor = 'wait';

            let result = await airtable_service.get_tables(this.airtable_credential, this.airtable_base_id)
                                                        .catch(err => {
                                                            this.errorMessage = err.name === 401 ?
                                                                "Erreur d'authentification, vérifiez le nom et la valeur de votre credential"
                                                                : "Erreur lors de la récupération des tables";
                                                        });

            if (result === undefined) {
                this.promisePending = false;
                return;
            }
            console.log("Got tables: ", result);
            this.tablesList = result.tables;

            this.tableOptions = this.tablesList.map(t => {
                return { text: t.name, value: t.id };
            });

            if (this.tableOptions.length > 0) {
                this.airtable_table_id = this.tableOptions[0].value;
                // get_fields will auto-run after watching table id get updated
                // this.get_fields();
            } else {
                this.promisePending = false;
                this.errorMessage = "Aucune table trouvée";
            }

            // if (this.exportMode && this.smd_table_name.length > 0) {
            //     this.tableOptions.push({
            //         text: "Nouvelle table: " + this.smd_table_name,
            //         value: this.smd_table_name
            //     });
            // }

            // document.body.style.cursor = 'default';
        },

        get_mapping: async function() {
            this.errorMessage = "";

            // returns the mapping for the table
            // change mouse to waiting state
            // document.body.style.cursor = 'wait';
            this.promisePending = true;

            // if base_id is set, try to get the fields
            if (this.smd_table_name.length > 0) {
                let mapping = await airtable_service.get_mapping(this.smd_table_name);
                // inform a dropdown
                // this.airtable_fields = fields;
                if (mapping.length === 0) {
                    console.warn(`Table ${this.smd_table_name} n'existe pas`);
                    // document.body.style.cursor = 'default';
                    promisePending = false;
                    return;
                }
                // console.log(mapping);
                // console.log("mapping", JSON.parse(mapping[0].mapping_colonnes));

                this.airtable_fields = JSON.parse(mapping[0].mapping_colonnes);
                this.fieldMappings = JSON.parse(mapping[0].mapping_colonnes);
            }

            // this.tableHasDocuments = this.airtable_fields.find(f => f.type === "multipleAttachments");

            // change mouse back to normal
            // document.body.style.cursor = 'default';
            this.promisePending = false;

        },

        export_airtable: async function() {
            this.errorMessage = "";

            // document.body.style.cursor = 'wait';
            this.promisePending = true;

            // remove fieldMapping if type === undefined
            this.fieldMappings = this.fieldMappings.filter(f => f.type !== undefined);

            await airtable_service.export_airtable(this.airtable_credential,
                                                    this.airtable_base_id,
                                                    this.airtable_table_id,
                                                    this.smd_table_name,
                                                    this.fieldMappings)
                                                    .catch(err => {
                                                        this.errorMessage = "Erreur lors de l'export de la table"
                                                    });

            // document.body.style.cursor = 'default';
            this.promisePending = false;

            this.$emit("exported");
        },
    },
    watch: {
        airtable_base_id: function() {
            this.get_tables();
        },
        airtable_table_id: function() {
            this.get_fields();
        }
    },
    mounted: function() {
        // console.log jwt
        this.get_credentials();
        this.promisePending = false;
    },
    computed: {
        info_filled: function() {
            return this.airtable_credential.length > 0 && this.airtable_base_id.length > 0 && this.airtable_table_id.length > 0;
        }
    },
}

</script>